import { useCheckoutCoupons } from '~/domains/coupons/queries';
import type { CART_TYPE } from '~/hooks/useCartTypeParam';

import { useMembershipStatus } from './useMembershipStatus';
import { useMembershipRegisteredExpectedAmountNudge } from '../queries';

export const useLuckyBonusPackCouponNudge = ({
  buyerCouponId,
  cartType,
  point,
}: {
  buyerCouponId?: number;
  cartType: CART_TYPE;
  point?: number;
}) => {
  const { isAvailableToSubscribeBonusPack } = useMembershipStatus();

  const { data: nudgeData } = useMembershipRegisteredExpectedAmountNudge(
    {
      cartType,
      buyerCouponIds: buyerCouponId ? [buyerCouponId] : [],
      point,
    },
    { keepPreviousData: true },
  );

  const { data: checkoutCoupons } = useCheckoutCoupons(cartType);

  const maxCouponDiscountAmount =
    checkoutCoupons?.checkoutBuyerCoupons?.[0]?.calculatedDiscountAmount ?? 0;

  const nudgeCouponDiscountAmount =
    nudgeData?.discountItems.find(
      ({ discountType }) => discountType === 'COUPON',
    )?.discountAmount || 0;

  const isShowLuckyBonusPackCouponNudge =
    isAvailableToSubscribeBonusPack &&
    nudgeCouponDiscountAmount > maxCouponDiscountAmount;

  return {
    ...nudgeData,
    isShowLuckyBonusPackCouponNudge,
    maxCouponDiscountAmount,
    nudgeCouponDiscountAmount,
  };
};
